import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type * as React from 'react';
import { getIcon } from '@/lib/icons';
import { cn } from '@/lib/utils';

export interface IconProps extends Omit<React.ComponentProps<'span'>, 'children'> {
  name: string;
  solid?: boolean;
  spin?: boolean;
}

export function Icon({ name, solid = false, spin = false, className, ...props }: IconProps) {
  const icon = getIcon(name, solid);
  if (!icon) {
    if (process.env.NODE_ENV === 'development') {
      console.warn(`Icon "${name}" not found in registry (solid=${solid})`);
    }
    return null;
  }
  return (
    <span className={cn('inline-flex items-center justify-center', className)} {...props}>
      <FontAwesomeIcon icon={icon} spin={spin} />
    </span>
  );
}
